import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MessageAdmin = ({ darkMode, showNotification }) => {
  const [formData, setFormData] = useState({ channel: '0', message: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      navigate('/login');
      return;
    }

    const user = JSON.parse(storedUser);
    if (!user.roles.includes('admin')) {
      showNotification && showNotification('Admin access required', 'error');
      navigate('/');
      return;
    }
  }, [navigate, showNotification]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/mqtt/send-message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (res.ok) {
        showNotification && showNotification('Message sent successfully', 'success');
        setFormData({ channel: '0', message: '' });
      } else {
        showNotification && showNotification(data.error || 'Failed to send message', 'error');
      }
    } catch (err) {
      showNotification && showNotification('Unexpected error occurred', 'error');
      console.error(err);
    }
  };

  return (
    <div className={`max-w-2xl mx-auto p-6 pb-24 rounded shadow-md ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'}`}>
      <h2 className="text-2xl font-bold mb-6">Admin Message Sender</h2>
      <form className="space-y-4" onSubmit={handleSubmit}>
        {/* Dropdown replaces channel input */}
        <label className="block">
          <span className="block mb-1 font-semibold">Channel</span>
          <select
            name="channel"
            value={formData.channel}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${darkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'}`}
          >
            <option value="0">Default</option>
            <option value="1">Vardal</option>
          </select>
        </label>

        <textarea
          name="message"
          placeholder="Your message..."
          rows="5"
          value={formData.message}
          onChange={handleChange}
          className={`w-full p-2 border rounded ${darkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'}`}
        ></textarea>

        <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700">
          Send Message
        </button>
      </form>
    </div>
  );
};

export default MessageAdmin;
